import type {components, paths} from '../../openapi';
import {axiosInstance} from '../axiosInstance';

type FetchBannersOperation = paths['/executor_web/banners']['get'];
type BannersPayload = FetchBannersOperation['responses'][200]['content']['application/json'];

export type Banner = components['schemas']['Banner'] & {
	deeplink?: string | null;
};

export type FetchBannersResponse = Omit<BannersPayload, 'data'> & {
	data?: Banner[];
};

/** GET `/executor_web/banners` — актуальные баннеры пользователя */
export function fetchBanners(signal?: AbortSignal) {
	return axiosInstance.get<FetchBannersResponse>('banners', {signal});
}
